import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@shared/guards';

const routes: Routes = [
  { path: '', redirectTo: 'app', pathMatch: 'full' },
  {
    path: 'app',
    loadChildren: './modules/main-app/main-app.module#MainAppModule'
  },
  {
    path: 'dashboard',
    loadChildren: './modules/dashboard/dashboard.module#DashboardModule',
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    loadChildren: './modules/login/login.module#LoginModule'
  },
  {
    path: 'signup',
    loadChildren: './modules/sign-up/sign-up.module#SignUpModule'
  },
  {
    path: 'preorder',
    loadChildren: './modules/pre-order/pre-order.module#PreOrderModule'
  },
  {
    path: 'reset',
    loadChildren:
      './modules/reset-password/reset-password.module#ResetPasswordModule'
  },
  {
    path: 'confirm',
    loadChildren: './modules/confirm/confirm.module#ConfirmModule'
  },
  {
    path: '**',
    redirectTo: 'app'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      useHash: true
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
